<div class="cvds-structure">

  <div *ngIf="fieldsModel.length">
    <cv-cvds-field-table
      [items]="fieldsModel"
      [title]="'Structure ' + (index + 1)"
    ></cv-cvds-field-table>
  </div>

  <div *ngFor="let item of fieldsSections">
    <cv-cvds-field-array
      [items]="item.items"
      [fields]="item.fields"
      [title]="item.title"
    ></cv-cvds-field-array>
  </div>

  <div *ngIf="structure.cv_photos?.length">
    <div class="card cv-card__main shadow-sm">
      <div class="card-header">Structure Photos</div>
      <div class="card-body">
        <cv-cvds-photos 
          [photos]="structure.cv_photos">
        </cv-cvds-photos>
      </div>
    </div>
  </div>

  <div class="card cv-card__main shadow-sm" *ngIf="structure.units.length > 0">
    <div class="card-header">Units</div>
    <div class="card-body">

      <cv-tab-group>
        <cv-tab [title]="unit.unitType.Value" *ngFor="let unit of structure.units; let i = index;">
            <div class="padding">
                <cv-cvds-unit [unit]="unit" [index]="i"></cv-cvds-unit>
            </div>
        </cv-tab>
      </cv-tab-group>
      
    </div>
  </div>

</div>